import { Box, Button, CardMedia, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router'

import { ErrorServer, Loading } from '~/components'
import { loadingStates } from '~/config/constant'
import { variantStyles } from '~/theme/constants'
import { bigBell } from '../../assets/images'
import { isDeviceSmall, marginX } from '../../constants'

import { infoCallStaffSelector } from './callStaffSlice'
import { path } from '~/routes/path'
import { useAppContext } from '~/contexts/AppContext'

const CallStaff = () => {
  const { t } = useTranslation()
  const navigation = useNavigate()
  const { error, loading, servingSessionID } = useSelector(infoCallStaffSelector)
  const { saveServingSessionID, heightHeaderFixed } = useAppContext()

  useEffect(() => {
    // Cập nhật servingSessionID trong trường hợp separate order
    if (servingSessionID) {
      saveServingSessionID(servingSessionID)
    }
  }, [saveServingSessionID, servingSessionID])

  const goBackToMenu = () => {
    navigation(path.indexMenu)
  }

  if (loading === loadingStates.pending) return <Loading />

  if (error) return <ErrorServer />

  return (
    <Box style={styles.container} marginTop={`${heightHeaderFixed}px`}>
      <Box style={styles.boxBell} marginTop={`${heightHeaderFixed}px`}>
        <CardMedia component="img" image={bigBell} alt="bell" style={styles.imgBell} />
      </Box>
      <Box>
        <Typography
          fontWeight="700"
          component="h2"
          style={styles.title}
          color="baseColor.colorText1">
          {t('titles.call_staff')}
        </Typography>
        <Typography color="baseColor.colorText1" style={styles.description}>
          {t('descriptions.call_staff')}
        </Typography>
        <Box position="fixed" left={marginX} right={marginX} bottom={8}>
          <Button
            onClick={goBackToMenu}
            variant={variantStyles.btnAddToOrder}
            style={styles.button}>
            {t('actions.back_to_menu')}
          </Button>
        </Box>
      </Box>
    </Box>
  )
}

export default React.memo(CallStaff)

const styles = {
  container: {
    flex: 1,
    marginLeft: marginX,
    marginRight: marginX,
    paddingBottom: 100,

    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    backgroundColor: 'baseColor.color1',
  },
  boxBell: {
    textAlign: 'right',
  },
  imgBell: {
    display: 'inline-block',
    width: isDeviceSmall ? 180 : 200,
  },
  title: {
    fontSize: isDeviceSmall ? '3rem' : '4rem',
    lineHeight: 1.2,
    marginTop: isDeviceSmall ? 80 : 140,
    color: 'baseColor.colorText1',
  },
  description: {
    fontSize: '1.4rem',
    fontWeight: '500',
    width: '90%',
    color: 'baseColor.colorText1',
  },
  button: {
    fontSize: '2.2rem',
    borderWidth: 2,
    width: '100%',
  },
}
